module.exports = __webpack_public_path__ + "img/mark_face_side_image.d037d4a1.svg";